import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';

import { QCenter, QNotFound, QSpinner } from '@qualio/ui-components';

import { EventSteps } from '../../../components';
import { useEventPageData } from '../../../hooks/useEventPageData';
import { filterOwnersByPrivateTags } from '../../../utils/eventUtils';

export const EventDetailsContent: React.FC = () => {
  const { eventId } = useParams<{ eventId: string }>();
  const { eventData, refetch, usersData, userTZ, tagsData, isEventError } = useEventPageData(Number(eventId));
  const contentStepAssignees = useMemo(
    () => (tagsData ? filterOwnersByPrivateTags(usersData ?? [], tagsData, eventData?.issue.tags_ids ?? []) : []),
    [usersData, tagsData, eventData?.issue.tags_ids],
  );

  // The event couldn't be fetched (e.g. a 404 for a deleted / non-existent event, or another
  // fetch failure after retries). Show the not-found page instead of spinning forever.
  if (isEventError && !eventData) {
    return <QNotFound data-cy="event-not-found" />;
  }

  if (!eventData) {
    return (
      <QCenter pt={10}>
        <QSpinner />
      </QCenter>
    );
  }

  return (
    <EventSteps
      eventId={eventData.issue.id}
      eventDueDate={eventData.issue.due_date}
      steps={eventData.steps}
      users={usersData ?? []}
      contentStepAssignees={contentStepAssignees}
      refetch={refetch}
      userTZ={userTZ}
    />
  );
};
